import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { getProjectNamesFromCookies, setLocation } from './cookies';


export const ProjectDropList = React.memo(() => {
  const [isDropListOpen, setDropList] = useState(false)
  const dropListRef = useRef<HTMLDivElement>(null)

  let projectsFromCookies: Array<{ projectName: string, projectId: number }> = getProjectNamesFromCookies()
  if (!projectsFromCookies) {
    projectsFromCookies = [] as Array<{ projectName: string, projectId: number }>
  }


  useEffect(() => {
    if (!isDropListOpen) return

    const handleclick = (e: MouseEvent): void => {
      if (!dropListRef.current) return
      if (!dropListRef.current?.contains(e.target as Node)) {
        setDropList(false);
      }
    }
    document.addEventListener('click', handleclick)

    return () => {
      document.removeEventListener('click', handleclick)
    }
  }, [isDropListOpen])


  return (
    <span ref={dropListRef}>
      <span className={isDropListOpen ? 'myProjectsSelectisOpened' : 'myProjectsSelect'} onClick={() => setDropList(!isDropListOpen)}>
        | Projects</span>
      <Box className='dropList' sx={{ visibility: isDropListOpen ? 'visible' : 'hidden', position: 'absolute' }}>
        <nav aria-label="secondary mailbox folders">
          <List>
            {projectsFromCookies.map((pr) => (
                <ListItem disablePadding className='dropListLink' key={pr.projectId}>
                  <ListItemButton className='dropListLink' 
                  component="a" href={`/project/${pr.projectName}`} 
                  onClick={() => {
                    setLocation(pr.projectName, pr.projectId)
                  }}>
                    <ListItemText primary={pr.projectName} />
                  </ListItemButton>
                </ListItem>
            ))}
          </List>
        </nav>
      </Box>
    </span>
  );
})
